module.exports = __webpack_public_path__ + "static/media/controlador-01.f5d2822c.jpg";